import React from 'react'
import { Icon } from '@manychat/manyui'

import cm from './RemoveButton.module.css'

interface RemoveButtonProps {
  onClick: (event: React.MouseEvent) => void
}
export const RemoveButton = ({ onClick }: RemoveButtonProps) => {
  return (
    <span key="condition-remove-button" onClick={onClick}>
      <Icon.Close size={16} className={cm.icon} />
    </span>
  )
}
